<template>
  <v-app>
    

    <v-main>
      <v-container fluid>
        <router-view>
          <!-- Ici s'affiche la vue correspondande à l'url demandé -->
        </router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  export default {
    mounted(){
      
    }
  }
</script>


<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Poppins%3A200%2C400%2C400i%2C500%2C600%2C700%7CRoboto%3A300%2C300i%2C400%2C400i%2C500%2C500i%2C700%2C900%7CPacifico%7COpen%20Sans%3A300%2C300i%2C400%2C400i%2C600%2C600i%2C700%2C700i&#038;subset=latin,latin%2Clatin-ext&#038;display=swap" />
<style scoped>
  .v-application {
    background-color: #FFFFFF !important;
    
    color: blue;
  }
</style>
